
        <sk-wave [color]="color" [isRunning]="isRunning"></sk-wave>
    